import { MoreOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      copyright={false}
      style={{
        background: 'none',
      }}
      links={[
        {
          key: 'Lotto CMS',
          title: 'Lotto CMS',
          href: 'https://marvels.technology',
          blankTarget: true,
        },
        {
          key: 'divider',
          title: <MoreOutlined />,
          href: '',
        },
        {
          key: 'Marvels Technology',
          title: 'Marvels Technology',
          href: 'https://marvels.technology',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
